// @ vendor
const classnames = require('classnames');

// @ utilities
const { formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');

// @ constant
const TYPE_OF_ROADS = require('constants/typeOfRoadsList');
const { SECOND_STEP } = require('constants/index');

const insuranceRequestBuildRelatedAddressItem = (immInsuranceState, immInsuranceWizardState, preAppraisalNotificationFlag) => {
    let immLivingPlace = immInsuranceState.getIn(['appraisal', 'property']);

    const addressError = !immLivingPlace;
    const populationFromCurrent = immInsuranceState.getIn(['data', 'home', 'population']);
    const isPostAppraisal = immInsuranceState.getIn(['appraisal', 'afterAppraisal']);
    let populationLabel;
    let currentStep;
    if (!!immInsuranceWizardState) {
        const immInsuranceWizardStep2 = immInsuranceWizardState.getIn(['steps', SECOND_STEP]);
        currentStep = immInsuranceWizardState.get('visibleStep');
        populationLabel = immInsuranceWizardStep2.get('populationLabel');
    }

    let summaryAddress = formatText('insuranceRequestHome-summaryToBeDefined');
    const hasAdressAndCurrent = !!populationFromCurrent && currentStep !== 2;

    if (isPostAppraisal || preAppraisalNotificationFlag && !!immLivingPlace && (populationLabel || hasAdressAndCurrent)) {
        const streetType = TYPE_OF_ROADS[immLivingPlace.get('streetType')];
        const showStreetType = streetType || '';
        const street = immLivingPlace.get('street');
        const number = immLivingPlace.get('streetNumber');
        const population = populationLabel || populationFromCurrent || '';

        summaryAddress = `${showStreetType} ${street}, ${number}, ${population}`;
    }

    return {
        label: formatText('insuranceRequestHome-summaryAddress'),
        text: toCamelCase(summaryAddress),
        className: classnames({
            'insurance-request-compilation-card__text--disabled': addressError
        })
    };
}

module.exports = insuranceRequestBuildRelatedAddressItem;
